module.exports = __webpack_public_path__ + "static/media/jw_black.f05d77d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/balloons/jw_black.png
// module id = 775
// module chunks = 0